import "core-js/modules/es.error.cause.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.for-each.js";
import topTitle from '@/components/title';
import { mapState } from 'vuex';
import { isPhone, checkEmail, isTel } from '@/utils/validate';
import { invoicing } from '../request';
export default {
  components: {
    topTitle
  },
  data() {
    return {
      form: {
        type: undefined,
        taxpayerType: 'C',
        invoiceHead: '',
        taxpayerNo: '',
        mobile: '',
        email: '',
        companyBank: '',
        companyAccount: '',
        companyTel: '',
        companyAddress: '',
        remark: '',
        receiveType: undefined
      },
      invoiceTypeList: [{
        key: 'MERGE',
        name: '多笔保单金额汇总开具发票'
      }, {
        key: 'MULTIPLE',
        name: '多笔保单逐笔开具发票'
      }],
      invoiceHeadTypeList: [{
        id: 'P',
        name: '个人'
      }, {
        id: 'C',
        name: '公司'
      }],
      receiveTypeList: [{
        id: 'mobile',
        name: '手机号'
      }, {
        id: 'email',
        name: '电子邮箱'
      }],
      loading: false
    };
  },
  computed: {
    rules() {
      return {
        type: [{
          required: true,
          message: this.$t('请选择') + this.$t('开具发票方式'),
          trigger: 'blur'
        }],
        taxpayerType: [{
          required: true,
          message: this.$t('请选择') + this.$t('抬头类型'),
          trigger: 'blur'
        }],
        invoiceHead: [{
          required: true,
          validator: this.checkInvoiceHead,
          trigger: 'blur'
        }],
        taxpayerNo: [{
          required: true,
          message: this.$t('请输入') + this.$t('纳税人识别号'),
          trigger: 'blur'
        }],
        receiveType: [{
          required: true,
          message: this.$t('请选择') + this.$t('发票接收方式'),
          trigger: 'blur'
        }],
        mobile: [{
          required: false,
          validator: this.checkMobile,
          trigger: 'blur'
        }],
        email: [{
          required: false,
          validator: this.checkEmail,
          trigger: 'blur'
        }],
        companyTel: [{
          required: false,
          validator: this.checkTel,
          trigger: 'blur'
        }]
      };
    },
    ...mapState({
      invoiceList: state => JSON.parse(state.setting.chooseInvoice)
    }),
    // 多笔金额汇总
    invoicePrice() {
      if (this.form.type == 'MERGE') {
        let price = 0;
        this.invoiceList.forEach(item => {
          price += item.premium;
        });
        return price;
      }
    }
  },
  created() {
    if (this.$route.params.num == 1) {
      this.form.type = 'SINGLE';
    }
    console.log(this.invoiceList, 'this.invoiceList');
  },
  mounted() {},
  methods: {
    checkInvoiceHead(rule, value, callback) {
      if (this.form.taxpayerType === 'C') {
        if (!value) {
          callback(new Error(this.$t('请输入') + this.$t('发票抬头')));
        } else {
          callback();
        }
      } else if (!value) {
        callback(new Error(this.$t('请输入') + this.$t('开票姓名')));
      } else {
        callback();
      }
    },
    checkMobile(rule, value, callback) {
      if (value && !isPhone(value)) {
        callback(new Error(this.$t('请输入正确的手机号码')));
      } else {
        callback();
      }
    },
    checkEmail(rule, value, callback) {
      if (value && !checkEmail(value)) {
        callback(new Error(this.$t('请输入正确的电子邮箱')));
      } else {
        callback();
      }
    },
    checkTel(rule, value, callback) {
      if (value && !isTel(value)) {
        callback(new Error(this.$t('请输入正确的公司联系电话')));
      } else {
        callback();
      }
    },
    // 只允许输入数字和-符号
    mobileInput() {
      this.form.companyTel = this.form.companyTel.replace(/[^\d-]/g, '');
    },
    handleBlurTrim(key) {
      this.form[key] = this.form[key].trim();
    },
    //  切换开具发票方式清空数据
    invoiceTypeChange(val) {
      this.form = this.$options.data().form;
      this.form.type = val;
      // 清空错误校验
      this.$refs.ruleForm.clearValidate();
    },
    // 切换抬头清空数据
    taxpayerTypeChange(val) {
      this.form.invoiceHead = undefined;
      this.form.taxpayerNo = undefined;
      this.form.receiveType = undefined;
      this.form.mobile = undefined;
      this.form.email = undefined;
      this.form.companyBank = undefined;
      this.form.companyAccount = undefined;
      this.form.companyTel = undefined;
      this.form.companyAddress = undefined;
      this.form.remark = undefined;
      // 清空错误校验
      this.$refs.ruleForm.clearValidate();
      console.log(val, 'val');
      if (val === 'P') {
        this.form.invoiceHead = this.invoiceList[0].appliName;
      }
    },
    // 切换接收方式清空数据
    receiveTypeChange(val) {
      this.form.mobile = undefined;
      this.form.email = undefined;
      // 清空错误校验
      this.$refs.ruleForm.clearValidate();
    },
    onSubmit() {
      this.$refs.ruleForm.validate(async valid => {
        if (valid) {
          if (!this.form.mobile && !this.form.email) {
            this.$message.error(this.$t('至少填写1个接收方式'));
            return;
          }
          this.loading = true;
          // 处理保单编号
          let policyNo = [];
          this.invoiceList.forEach(item => {
            policyNo.push(item.policyNo);
          });
          await invoicing({
            ...this.form,
            customerId: this.$route.query.customerId,
            applicationId: this.$route.query.applicationId,
            insuranceId: this.$route.query.insuranceId,
            policyNo: policyNo.join(','),
            invoiceHeadType: this.form.taxpayerType === 'C' ? 'OTHER' : 'APPLICANT',
            receiveType: undefined
          }).then(res => {
            this.$message.success(this.$t('申请发票提交成功'));
            this.loading = false;
            // 返回上一页，并更新store中的数据为空，清除缓存
            this.$router.replace({
              path: '/invoiceManage/customerManage/invoiceList'
            });
            this.$store.dispatch('setting/setChooseInvoice', '');
            sessionStorage.removeItem('chooseInvoice');
          }).catch(err => {
            this.loading = false;
          });
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    }
  }
};